/**
 * Mini-pictogrammes SVG pour la palette de pose (section, tiroir, penderie, tablettes, porte).
 * Utilisés dans les DragPill pour que l'artisan voit d'un coup d'œil ce qu'il glisse.
 */
export function MiniIcon({ kind, size = 20, color = "#0465C1" }) {
  const s = size;
  if (kind === "section") {
    return (
      <svg width={s} height={s} viewBox="0 0 24 24" fill="none">
        <rect x="4" y="3" width="16" height="18" rx="1" stroke={color} strokeWidth="1.5" />
        <line x1="12" y1="4" x2="12" y2="20" stroke={color} strokeWidth="2.4" />
        <path d="M9 8 L12 5 L15 8 M9 16 L12 19 L15 16" stroke={color} strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    );
  }
  if (kind === "drawer") {
    return (
      <svg width={s} height={s} viewBox="0 0 24 24" fill="none">
        <rect x="3" y="6" width="18" height="12" rx="1.5" stroke={color} strokeWidth="1.6" />
        <rect x="9" y="11" width="6" height="2" rx="1" fill={color} />
      </svg>
    );
  }
  if (kind === "penderie") {
    return (
      <svg width={s} height={s} viewBox="0 0 24 24" fill="none">
        <line x1="3" y1="8" x2="21" y2="8" stroke={color} strokeWidth="2" strokeLinecap="round" />
        <rect x="3" y="6" width="2" height="4" rx="0.5" fill={color} />
        <rect x="19" y="6" width="2" height="4" rx="0.5" fill={color} />
        <path d="M8 12 L16 12 L14 18 L10 18 Z" stroke={color} strokeWidth="1.5" fill="none" strokeLinejoin="round" />
        <path d="M10 12 Q12 9 14 12" stroke={color} strokeWidth="1.5" fill="none" strokeLinecap="round" />
      </svg>
    );
  }
  if (kind === "shelf_fixed") {
    return (
      <svg width={s} height={s} viewBox="0 0 24 24" fill="none">
        <rect x="3" y="10" width="18" height="4" rx="0.5" fill={color} />
        <line x1="3" y1="10" x2="3" y2="14" stroke={color} strokeWidth="2" />
        <line x1="21" y1="10" x2="21" y2="14" stroke={color} strokeWidth="2" />
      </svg>
    );
  }
  if (kind === "shelf_mobile") {
    return (
      <svg width={s} height={s} viewBox="0 0 24 24" fill="none">
        <line x1="3" y1="12" x2="21" y2="12" stroke={color} strokeWidth="2.5" strokeDasharray="3 2" strokeLinecap="round" />
      </svg>
    );
  }
  if (kind === "door") {
    return (
      <svg width={s} height={s} viewBox="0 0 24 24" fill="none">
        <rect x="5" y="3" width="14" height="18" rx="1.2" stroke={color} strokeWidth="1.6" />
        <circle cx="16" cy="12" r="1" fill={color} />
      </svg>
    );
  }
  if (kind === "mirror") {
    return (
      <svg width={s} height={s} viewBox="0 0 24 24" fill="none">
        <rect x="5" y="3" width="14" height="18" rx="1" stroke={color} strokeWidth="1.6" />
        <line x1="8" y1="5" x2="8" y2="19" stroke={color} strokeWidth="1" strokeDasharray="1.5 1.5" opacity="0.7" />
        <line x1="12" y1="5" x2="12" y2="19" stroke={color} strokeWidth="1" strokeDasharray="1.5 1.5" opacity="0.5" />
        <line x1="16" y1="5" x2="16" y2="19" stroke={color} strokeWidth="1" strokeDasharray="1.5 1.5" opacity="0.3" />
      </svg>
    );
  }
  return null;
}
